// 標準 ASCII 特殊字符 (共 32 個): ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \ ] ^ _ ` { | } ~
const SPECIAL_CHAR_REGEX = /[!-/:-@[-`{-~]/

// 密碼只能使用英數字 + 32 個特殊字符 (即 ASCII 可見字元，不含空格)
const ALLOWED_CHARS_REGEX = /^[!-~]*$/

// 登入密碼強度規則 (OKF-2440)
export const PASSWORD_RULES = [
  { key: 'length', label: 'old:pwdRuleLength', test: (value: string) => value.length >= 8 }, // 至少8位字符
  { key: 'number', label: 'old:pwdRuleNumber', test: (value: string) => /\d/.test(value) }, // 至少1個數字
  { key: 'upper', label: 'old:pwdRuleUpper', test: (value: string) => /[A-Z]/.test(value) }, // 至少1個大寫字母
  { key: 'lower', label: 'old:pwdRuleLower', test: (value: string) => /[a-z]/.test(value) }, // 至少1個小寫字母
  { key: 'special', label: 'old:pwdRuleSpecial', test: (value: string) => SPECIAL_CHAR_REGEX.test(value) }, // 至少1個特殊字符
] as const

// 登入密碼最大長度
export const PASSWORD_MAX_LENGTH = 20

// 逐條檢查規則
export const checkPasswordRules = (value: string) => PASSWORD_RULES.map((rule) => ({ ...rule, met: rule.test(value) }))

// 是否含有不允許的字元 (空格、中文、全形符號、emoji 等)
export const hasInvalidPasswordChar = (value: string) => !ALLOWED_CHARS_REGEX.test(value)

// 是否滿足全部規則且沒有不允許的字元
export const isStrongPassword = (value: string) => !hasInvalidPasswordChar(value) && PASSWORD_RULES.every((rule) => rule.test(value))

// 強度條顏色: 0-39% 紅色，40-79% 黃色，80-100% 綠色
export const getStrengthColor = (percent: number) => {
  if (percent < 40) return '#E80206'
  if (percent < 80) return '#FFC310'
  return '#00C784'
}
